import {UseCase} from '@s-ui/domain'

export class GetPageTrackingDataUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Object} deps.config
   * @param {Function} deps.trackingDataService
   */
  constructor({config, trackingDataService}) {
    super({config, trackingDataService})

    this._trackingDataService = trackingDataService
  }

  /**
   * @param {Object} params
   * @param {Array} params.ad.highlightType
   * @param {Array} params.advertisements
   * @param {Array} params.merchantList
   * @param {Array} params.similarAds
   * @param {Array} params.vehicles
   * @param {Boolean} params.ad.vehicleHistory
   * @param {Number} params.ad.id
   * @param {Number} params.ad.price
   * @param {Number} params.httpStatusCode
   * @param {Number} params.pageNumber
   * @param {Object} params.ad
   * @param {Object} params.ad.priceDropData
   * @param {Object} params.adDetail
   * @param {String} params.city
   * @param {Object} params.filters
   * @param {String} params.formName
   * @param {Object} params.instantOffer
   * @param {Object} params.lastFilter
   * @param {Object} params.search
   * @param {String} params.bodyType
   * @param {String} params.category
   * @param {String} params.contactType
   * @param {String} params.culture
   * @param {String} params.event
   * @param {String} params.make
   * @param {String} params.model
   * @param {String} params.origin
   * @param {String} params.page
   * @param {String} params.pageName
   * @param {String} params.pageOrigin
   * @param {String} params.pageType
   * @param {String} params.province
   * @param {String} params.referer
   * @param {String} params.searchResultsCount
   * @param {String} params.searchTerm
   * @param {String} params.section
   * @param {String} params.step
   * @param {String} params.tag
   * @param {String} params.title
   * @param {String} params.url
   * @param {String} params.version
   * @return {Promise<Object, Error>} This is a Promise return value.
   */
  execute(params) {
    return this._trackingDataService.execute(params)
  }
}
